module.exports = __webpack_public_path__ + "static/media/users-image.610f8e12.svg";